import React from "react"
import PropTypes from "prop-types"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Person from "../images/person.inline.svg";
import Skip from "../images/skip.inline.svg";
import ReactTooltip from "react-tooltip";

const Card = ({ title, featured, size, skipWidth, tip }) => (
  <div className={featured ? `border-3 border-secondary relative bg-white shadow-lg rounded text-center p-10 h-full` : `bg-white shadow-lg rounded text-center p-10 h-full`}>
    {featured && 
      <div className="absolute top-0 left-0 right-0 ">
        <div className="bg-secondary text-white text-base md:text-lg mx-auto py-1 w-56 rounded-full -mt-5">
          <span className="block"><FontAwesomeIcon className="text-sm inline-block" icon="star" /> Most Popular!</span>
        </div>
      </div>
    }
    <h2>
      {title}
      <span
        className="rounded-full ml-2 inline-block cursor-pointer w-5 h-5 text-sm text-white text-center bg-secondary"
        data-tip={tip}
      >
        <FontAwesomeIcon className="block text-xs mx-auto mt-1" icon="info" />
      </span>
    </h2>
    <ReactTooltip place={`right`} effect={`solid`} clickable={true} className={`text-base bg-primary`} />
  

    <span className="block bg-grey-light text-secondary-light rounded-full py-2 px-8 mb-6 md:mb-10">{size}</span>

    <div className="mb-6 md:mb-10 mx-auto flex justify-center">
      <Person className="w-12 -mr-6 relative z-10" />
      <Skip className={skipWidth} />
    </div>

    <a href="#quote" className="btn">Get a Quote</a>
  </div>
)

Card.propTypes = {
  title: PropTypes.string,
  size: PropTypes.string,
  skipWidth: PropTypes.string,
  tip: PropTypes.string,
  featured: PropTypes.bool
}

Card.defaultProps = {
  title: ``,
  size: ``,
  skipWidth: ``,
  tip: ``,
  featured: false
}

export default Card